import Header from "../components/Header";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-white" data-testid="privacy-policy-page">
      <Header />
      
      <main className="pt-[75px] md:pt-[83px] pb-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/" className="inline-flex items-center text-navy hover:text-gold mb-8 transition-colors">
            <ChevronLeft size={20} />
            <span>Back to Home</span>
          </Link>
          
          <h1 className="font-heading font-bold text-3xl md:text-4xl text-navy mb-8">
            Privacy Policy
          </h1>
          
          <div className="prose prose-slate max-w-none">
            <p className="text-slate-600 mb-6">
              <strong>Effective Date:</strong> {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
            </p>
            
            <p className="text-slate-600 mb-6">
              WMJ Enterprise Services LLC is committed to protecting your privacy. 
              This Privacy Policy explains how we collect, use, disclose, and safeguard your information 
              when you visit our website or use our tax preparation and financial services.
            </p>

            <h2 className="font-heading font-semibold text-xl text-navy mt-8 mb-4">1. Information We Collect</h2>
            <p className="text-slate-600 mb-4">We may collect the following types of information:</p>
            <ul className="list-disc pl-6 text-slate-600 mb-6 space-y-2">
              <li><strong>Personal Information:</strong> Name, email address, phone number, mailing address, Social Security Number (for tax preparation), date of birth, and other identifying information.</li>
              <li><strong>Financial Information:</strong> Income details, tax documents, bank account information, investment records, and other financial data necessary for tax preparation.</li>
              <li><strong>Technical Information:</strong> IP address, browser type, device information, and website usage data collected through cookies and similar technologies.</li>
            </ul>

            <h2 className="font-heading font-semibold text-xl text-navy mt-8 mb-4">2. How We Use Your Information</h2>
            <p className="text-slate-600 mb-4">We use your information to:</p>
            <ul className="list-disc pl-6 text-slate-600 mb-6 space-y-2">
              <li>Provide tax preparation and financial consulting services</li>
              <li>Communicate with you about your account and services</li>
              <li>Comply with legal and regulatory requirements</li>
              <li>Improve our website and services</li>
              <li>Send you relevant updates and promotional materials (with your consent)</li>
            </ul>

            <h2 className="font-heading font-semibold text-xl text-navy mt-8 mb-4">3. Information Sharing</h2>
            <p className="text-slate-600 mb-6">
              We do not sell your personal information. We may share your information only:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-6 space-y-2">
              <li>With the IRS and state tax authorities as necessary to file your tax returns</li>
              <li>With trusted service providers who assist us in operating our business</li>
              <li>When required by law or to protect our legal rights</li>
              <li>With your explicit consent</li>
            </ul>

            <h2 className="font-heading font-semibold text-xl text-navy mt-8 mb-4">4. Data Security</h2>
            <p className="text-slate-600 mb-6">
              We implement industry-standard security measures to protect your personal and financial 
              information, including encryption, secure servers, and access controls. However, no method 
              of transmission over the Internet is 100% secure, and we cannot guarantee absolute security.
            </p>

            <h2 className="font-heading font-semibold text-xl text-navy mt-8 mb-4">5. Data Retention</h2>
            <p className="text-slate-600 mb-6">
              We retain your personal and tax information for as long as necessary to provide our services 
              and comply with legal requirements. Tax records are typically retained for a minimum of seven 
              years in accordance with IRS recommendations.
            </p>

            <h2 className="font-heading font-semibold text-xl text-navy mt-8 mb-4">6. Your Rights</h2>
            <p className="text-slate-600 mb-4">You have the right to:</p>
            <ul className="list-disc pl-6 text-slate-600 mb-6 space-y-2">
              <li>Access and review your personal information</li>
              <li>Request corrections to inaccurate information</li>
              <li>Request deletion of your information (subject to legal retention requirements)</li>
              <li>Opt out of marketing communications</li>
            </ul>

            <h2 className="font-heading font-semibold text-xl text-navy mt-8 mb-4">7. Contact Us</h2>
            <p className="text-slate-600 mb-6">
              If you have questions about this Privacy Policy or our data practices, please contact us at:
            </p>
            <div className="bg-slate-50 p-6 rounded-lg mb-6">
              <p className="text-slate-700 font-medium">WMJ Enterprise Services LLC</p>
              <p className="text-slate-600">Email: info@wmjenterpriseservices.com</p>
              <p className="text-slate-600">Phone: (901) 401-3054</p>
            </div>

            <h2 className="font-heading font-semibold text-xl text-navy mt-8 mb-4">8. Changes to This Policy</h2>
            <p className="text-slate-600 mb-6">
              We may update this Privacy Policy from time to time. We will notify you of any changes 
              by posting the new Privacy Policy on this page and updating the effective date.
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
